module.exports = "/fonts/line-awesome.woff2?452a5b42cb4819f09d35bcf6cbdb24c1";